import type { HTMLAttributes } from 'react';
import { cn } from '@/utils/cn';

export type PickemsSectionTitleProps = HTMLAttributes<HTMLHeadingElement>;

export const PickemsSectionTitle = ({
  children,
  className,
  ...props
}: PickemsSectionTitleProps) => {
  return (
    <h2
      className={cn('mb-5 font-bold text-2xl text-white', className)}
      {...props}
    >
      {children}
    </h2>
  );
};
